import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Product from "../views/Product.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/the-original",
    name: "product",
    component: Product
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
